import React, { lazy, useEffect } from "react";
import { Card } from "../../../../Units/Card.styled";
import { CardHolder, CardTitle } from "../../../../Units/CardTitle.styled";
import ic_activities from "../../../../../assets/images/ic-activities-db.svg";
import { groupActivitiesByDaysOrMonth } from "../../../../../utils/specialFunctions";
import { ActivitiesTableCardStyle } from "./Activities.styled";
import { connect } from "react-redux";
import { getAnnouncementAction } from "../../../../../store/Actions/Messages_AnnouncementsAction";
import ActivitiesTable from "./ActivitiesTable";
import { getP2PTransactions } from "../../../../../store/Actions/P2PActions";
import { useHistory } from "react-router-dom";

const ActivitiesCardTable = ({
  activities,
  updateActiveTab,
  getTransactions,
  // getAnnouncementAction,
}) => {
  useEffect(() => {
    getTransactions();
  }, [getTransactions]);

  const router = useHistory();
  return (
    <ActivitiesTableCardStyle className="pt-6">
      <Card>
        <CardHolder>
          <div className="flex">
            <div className="w-12/12">
              <CardTitle img={ic_activities} text={"Activities"} />
            </div>
          </div>
        </CardHolder>

        {/* <pre>{JSON.stringify(activities, null, 2)}</pre> */}
        <div className="lg:px-4">
          <ActivitiesTable
            activities={groupActivitiesByDaysOrMonth(
              activities ? activities : null,
              "days"
            ).slice(0, 5)}
          />
          {activities && activities.length !== 0 ? (
            <div className="text-center pt-5 flex justify-center">
              <button
                className="viewAll"
                onClick={(e) => {
                  e.preventDefault();
                  router.push("/dashboard/p2p/orders");
                }}
              >
                See more
              </button>
            </div>
          ) : null}
        </div>
      </Card>
    </ActivitiesTableCardStyle>
  );
};

const mapStateToProps = (state) => {
  return {
    activities: state.p2p.p2pTransactions,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getTransactions: (query) => dispatch(getP2PTransactions(query)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActivitiesCardTable);
